export const rechargeTypeList = [
    { id: 4, name: "Branch Recharge",idVal:'branchRecharge',nextId:'partyRecharge',prevId:'' },
    { id: 6, name: "Party Recharge",idVal:'partyRecharge',nextId:'maven',prevId:'branchRecharge'  },
    { id: 3, name: "Maven",idVal:'maven',nextId:'bkngDelQR',prevId:'partyRecharge'  },
    { id: 1, name: "Booking & Delivery QR",idVal:'bkngDelQR',nextId:'pos',prevId:'maven'  },
    { id: 2, name: "POS",idVal:'pos',nextId:'QRPaymentSettlementFor',prevId:'bkngDelQR'  },
]

export const bankDetailsList = [
    { name: "Account Name", type: "string", field: "accountName" },
    { name: "Account Number", type: "number", field: "accountNumber" },
    { name: "IFSC Code", type: "string", field: "IFSCCode" },
    { name: "Bank Name", type: "string", field: "bankName" },
    { name: "Registered Mob No", type: "number", field: "registeredMob" },
    { name: "Registered Email ID", type: "string", field: "registeredEmailID" },
    { name: "Settlement Days", type: "number", field: "settlementDays" },
    { name: "Transaction Fee ", type: "number", field: "transactionFee" },
]

export const QrPaymentSettlemntList = [
    { id: 0, name: "Comapny" },
    { id: 1, name: "Branch" },
]